export default __webpack_public_path__ + "static/media/reims14.35748cca.jpg";